import $ from 'jQuery';
import CircleType from '../../../js/development/before-libs/circletype.min.js';

export default function() {
    $(function(){
        if ($('#floating-circle-button').length > 0) {
            const circleText = new CircleType(document.getElementById('floating-circle-button'));
            $(circleText.element).fitText();
        }
    })
}